import "./StartHeader.css";



const Start = (props) => {

   
return (

    <div className="slide">

<h1>How well do you remember Pokemon: Indigo League?</h1>
    


    </div>

);

};

export default Start;